module.exports = __webpack_public_path__ + "static/cemetery-road-a4060b1fcf736d4d5ec745f4487a866f.jpg";